var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
import { __decorate, __metadata } from "tslib";
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Actions, Mutations } from '@/store/enums/hrgs/master/TukEnum';
import ApiService from '@/core/services/ApiService';
import { ElMessage } from 'element-plus';
import { ITukForm } from '@/core/types/entities/hrgs/master/TukEntities';
import { hrgsSwalAlert } from '@/core/helpers/sweet-alert';
import { Pagination } from '@/core/enums/Pagination';
const API_URL = `${process.env.VUE_APP_BASE_URL_DIGITAL}/${process.env.VUE_APP_MOBA_WEBAPI}`;
const API_URLS = {
    url: `${API_URL}/api/testplaces`
};
let TukModule = class TukModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.tukList = [];
        this.loading = false;
        this.pagination = {
            totalPage: 0,
            totalPageSize: 0,
            startPaginationIndex: 0,
            endPaginationIndex: 0,
            currentPage: 1
        };
        this.filter = {
            name: '',
            address: '',
            schemaId: ''
        };
        this.orderBy = null;
    }
    // *GETTERS
    get getTukList() {
        return this.tukList;
    }
    get getTukListLoading() {
        return this.loading;
    }
    get getTukListFilter() {
        return this.filter;
    }
    get getTukListPagination() {
        return this.pagination;
    }
    // *MUTATIONS
    [_a = Mutations.SET_TUK_LIST](data) {
        this.tukList = data;
    }
    [_b = Mutations.SET_TUK_LIST_LOADING](data) {
        this.loading = data;
    }
    [_c = Mutations.SET_TUK_LIST_FILTER](data) {
        this.filter = Object.assign(Object.assign({}, this.filter), data);
    }
    [_d = Mutations.RESET_TUK_LIST_FILTER]() {
        this.filter = {
            name: '',
            address: '',
            schemaId: ''
        };
    }
    [_e = Mutations.SET_TUK_LIST_PAGINATION](data) {
        const totalPage = data.totalItems || 0;
        const totalPageSize = data.pageSize || this.pagination.totalPageSize;
        const currentPage = data.currentPage || this.pagination.currentPage;
        this.pagination = {
            totalPage,
            totalPageSize,
            currentPage,
            startPaginationIndex: 0,
            endPaginationIndex: Math.floor(totalPage / totalPageSize)
        };
    }
    [_f = Mutations.SET_ORDER](data) {
        this.orderBy = data;
    }
    // *start: ACTION
    [_g = Actions.GET_LIST](payload) {
        var _u, _v, _w;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const filter = `SearchValues=${((_u = this.filter) === null || _u === void 0 ? void 0 : _u.name) || ''}&SearchValues=${((_v = this.filter) === null || _v === void 0 ? void 0 : _v.address) || ''}&SearchValues=${((_w = this.filter) === null || _w === void 0 ? void 0 : _w.schemaId) || ''}`;
        const params = Object.assign({ ver: 'v1', pageSize: (payload === null || payload === void 0 ? void 0 : payload.pageSize) || Pagination.DEFAULT_PAGE_SIZE, pageNo: (payload === null || payload === void 0 ? void 0 : payload.pageNo) || Pagination.DEFAULT_PAGE_NO }, (this.orderBy && {
            orderBy: this.orderBy
        }));
        this.context.commit(Mutations.SET_TUK_LIST_LOADING, true);
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}?${filter}&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                this.context.commit(Mutations.SET_TUK_LIST, resData.data);
                this.context.commit(Mutations.SET_TUK_LIST_PAGINATION, {
                    currentPage: params.pageNo,
                    pageSize: params.pageSize,
                    totalItems: resData.totalRecords
                });
                resolve(resData.data);
            })
                .catch((error) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed get TUK list.' });
                reject(error);
            })
                .finally(() => {
                this.context.commit(Mutations.SET_TUK_LIST_LOADING, false);
            });
        });
    }
    [_h = Actions.GET_DETAIL](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const data = response.data.result.content;
                resolve(data);
            })
                .catch((error) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed get TUK details.' });
                reject(error);
            });
        });
    }
    [_j = Actions.POST_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload;
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    this.context.commit(Mutations.RESET_TUK_LIST_FILTER);
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed create TUK.' });
                reject(_response);
            });
        });
    }
    [_k = Actions.UPDATE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = payload.data;
        return new Promise((resolve, reject) => {
            ApiService.put(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    this.context.commit(Mutations.RESET_TUK_LIST_FILTER);
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.result);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed update TUK.' });
                reject(_response);
            });
        });
    }
    [_l = Actions.DELETE_DATA](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API_URLS.url}/${employeeID}/${payload.id}?${new URLSearchParams(params).toString()}`)
                .then((res) => {
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else {
                    this.context.commit(Mutations.RESET_TUK_LIST_FILTER);
                    this.context.dispatch(Actions.GET_LIST);
                    resolve(res.data.statusCode);
                }
            })
                .catch((response) => {
                hrgsSwalAlert({ icon: 'error', text: 'Failed delete TUK.' });
                reject(response);
            });
        });
    }
    [_m = Actions.CREATE_EXPORT]() {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/exportcreate?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_o = Actions.CHANGE_EXPORT]() {
        var _u, _v, _w;
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const filter = `SearchValues=${((_u = this.filter) === null || _u === void 0 ? void 0 : _u.name) || ''}&SearchValues=${((_v = this.filter) === null || _v === void 0 ? void 0 : _v.address) || ''}&SearchValues=${((_w = this.filter) === null || _w === void 0 ? void 0 : _w.schemaId) || ''}`;
        const params = {
            ver: 'v1'
        };
        return new Promise((resolve, reject) => {
            ApiService.get(`${API_URLS.url}/${employeeID}/exportchange?${filter}&${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const resData = response.data.result.content;
                resolve(resData);
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_p = Actions.DOWNLOAD](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1',
            fileName: (payload === null || payload === void 0 ? void 0 : payload.fileName) || ''
        };
        return new Promise((resolve, reject) => {
            ApiService.getBlob(`${API_URLS.url}/${employeeID}/download?${new URLSearchParams(params).toString()}`)
                .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', params.fileName);
                document.body.appendChild(link);
                link.click();
                resolve();
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    [_q = Actions.UPLOAD_CHANGE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/changeupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload change tuk.'
                });
                reject(_response);
            });
        });
    }
    [_r = Actions.UPLOAD_SUBMIT_CHANGE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/changeupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload change tuk.'
                });
                reject(_response);
            });
        });
    }
    [_s = Actions.UPLOAD_CREATE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = new FormData();
        formdata.append('fileUpload', payload.fileUpload);
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/createupload?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed upload create tuk.'
                });
                reject(_response);
            });
        });
    }
    [_t = Actions.UPLOAD_SUBMIT_CREATE](payload) {
        const employeeID = this.context.getters.currentUser.employeeID;
        if (!employeeID) {
            ElMessage.error('Employee ID tidak ditemukan.');
            return false;
        }
        const params = {
            ver: 'v1'
        };
        const formdata = {
            request: payload.data
        };
        return new Promise((resolve, reject) => {
            ApiService.post(`${API_URLS.url}/${employeeID}/createupload/submit?${new URLSearchParams(params).toString()}`, formdata)
                .then((res) => {
                const resData = res.data.result.content;
                if (res.data.result.isError) {
                    hrgsSwalAlert({ icon: 'error', text: res.data.result.message });
                    reject();
                }
                else if (res.data.result.content.messageName) {
                    reject();
                }
                else {
                    resolve(resData);
                }
            })
                .catch((_response) => {
                hrgsSwalAlert({
                    icon: 'error',
                    text: 'Failed submit upload create tuk.'
                });
                reject(_response);
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _f, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _g, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _h, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_u = typeof ITukForm !== "undefined" && ITukForm) === "function" ? _u : Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _j, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _k, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _l, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _m, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _o, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _p, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _q, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _r, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _s, null);
__decorate([
    Action({ rawError: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TukModule.prototype, _t, null);
TukModule = __decorate([
    Module
], TukModule);
export default TukModule;
